import { render, staticRenderFns } from "./RecruitMainFooterArea.vue?vue&type=template&id=1eccc7f2&scoped=true"
import script from "./RecruitMainFooterArea.vue?vue&type=script&lang=js"
export * from "./RecruitMainFooterArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eccc7f2",
  null
  
)

export default component.exports